import React from "react";
import { Modal } from "reactstrap";
import "../style.css";
import ReactPlayer from "react-player";

class privacyModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			unmountOnClose: true,
		};
	}

	toggle = () => {
		this.props.that.setState({ vidModal: false });
	};

	changeUnmountOnClose = (e) => {
		let value = e.target.value;
		this.setState({ unmountOnClose: JSON.parse(value) });
	};

	render() {
		const { opener, videoLink } = this.props;
		return (
			<div>
				<Modal
					isOpen={opener}
					toggle={this.toggle}
					className="vidModal"
					size="lg"
					unmountOnClose={this.state.unmountOnClose}
				>
					<div className="vidContainer">
						<ReactPlayer
							width="100%"
							height="500px"
							playing={true}
							controls
							url={videoLink}
						/>
					</div>
				</Modal>
			</div>
		);
	}
}

export default privacyModal;
